import { render, staticRenderFns } from "./TabSelections.vue?vue&type=template&id=5c18df14&"
import script from "./TabSelections.vue?vue&type=script&lang=js&"
export * from "./TabSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports